import React, { useState } from "react";
import "../../index.css";
import "../../App.css";
import { Row, Switch } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { RootState, AppDispatch } from "./../../redux-toolkit/store/store";
import { handleAddAdditionalDetails } from "../../redux-toolkit/slices/painEntryFormSlice";
const TeAddMoreDetails: React.FC = ({}) => {
  const dispatch = useDispatch();
  const additionalDetailsClicked = useSelector(
    (state: RootState) => state.painEntryForm.additionalDetailsClicked
  );

  const handleSwitchChange = (checked: boolean) => {
    dispatch(handleAddAdditionalDetails(checked));
  };

  return (
    <div className="flex flex-col gap-2">
      <label className="h6 text-theme-text-secondary">
        <strong>Track symptoms, triggers, mood & energy</strong>
      </label>
      <p className="body1 text-theme-text-primary mb-4">
        Get deeper insights for better pain management
      </p>
      <div style={{ marginBottom: "10px" }}>
        <Switch
          checked={additionalDetailsClicked}
          onChange={handleSwitchChange}
          checkedChildren="On"
          unCheckedChildren="Off"
        />
      </div>
    </div>
  );
};

export default TeAddMoreDetails;
